/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { people } from "../assets/people";
import { Icon, type IconBaseProps } from "../icon";

export const IconPeople = (props: IconBaseProps) => <Icon {...props} svg={people} />;

IconPeople.displayName = "IconPeople";
